import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-default',
  templateUrl: './page-default.component.html',
  styleUrls: ['./page-default.component.scss']
})
export class PageDefaultComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
